import {
    useEffect,
} from 'react'

export default function useOutsideScroll(ref, handler) {
    useEffect(() => {
        function handleScrollOutside(event) {
            if (ref.current && !ref.current.contains(event.target)) {
                if (handler) handler()
            }
        }

        // Bind the event listener
        document.addEventListener('scroll', handleScrollOutside, {
            capture: true,
        })
        return () => {
            // Unbind the event listener on clean up
            document.removeEventListener('scroll', handleScrollOutside)
        }
    }, [
        ref,
        handler,
    ])
}
